import React from 'react';
import { Form, Input, Row, Col, InputNumber, DatePicker, Button, message } from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, postFrom, config } from '../../../../axios';
import moment from 'moment'

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {},
            id: null, //账单id
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadPackage = (id) => {
        this.setState({ loading: true, id });
        let data = { billId: id };
        postFrom({
            url: config.API_bill_getBillById,
            data,
        }).then(res => {

            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                values.billBeginDate = moment(Date.parse(values.billBeginDate)).format("YYYY-MM-DD");
                values.billEndDate = moment(Date.parse(values.billEndDate)).format("YYYY-MM-DD");
                values.mustPayDate = moment(Date.parse(values.mustPayDate)).format("YYYY-MM-DD");
                values.id = this.state.id;
                delete values.billCyclicity;

                post({
                    url: config.API_bill_edit,
                    data: values
                }).then(res => {

                    this.setState({ loading: false, data: {} });
                    this.props.handleCancel();
                    this.props.handleSearch();
                    message.success(`编辑成功`);
                }).catch(err => {
                    message.error(err.message || '接口异常');
                    this.setState({ loading: false })
                })
            }
        })
    }

    render() {
        let { visible, handleCancel, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data
        } = this.state;

        return <ModalDom
            title="账单编辑"
            visible={visible}
            loading={loading}
            onCancel={handleCancel}
            footer={
                <div>
                    <Button type="primary" onClick={this.handleOk} loading={loading}>
                        确定
                </Button>
                    <Button onClick={handleCancel}>取消</Button>
                </div>
            }
        >
            <div className="custom">
                <Form labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}>
                    <Row>
                        <Col>
                            <DetailTitle title="房源" boxStyle={{ marginTop: 0 }} />
                            <CustomRow>
                                <CustomCol label="楼栋/楼盘" required={false} >
                                    {getFieldDecorator('buildingName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.buildingName
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="房间号" required={false} >
                                    {getFieldDecorator('roomNo', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.roomNo
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        <Col>
                            <DetailTitle title="租客" />
                            <CustomRow>
                                <CustomCol label="姓名" required={false} >
                                    {getFieldDecorator('customerName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.customerName
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="证件号码" required={false} >
                                    {getFieldDecorator('credentialNumber', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.credentialNumber
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="手机号码" required={false} >
                                    {getFieldDecorator('customerPhone', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.customerPhone
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        <Col>
                            <DetailTitle title="账单" />
                            <CustomRow>
                                <CustomCol label="账单名称" required={false} >
                                    {getFieldDecorator('feeName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.feeName
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="应收日期" required={false} >
                                    {getFieldDecorator('mustPayDate', {
                                        rules: [{
                                            required: false, message: '请选择',
                                        }],
                                        initialValue: (data.mustPayDate ? moment(data.mustPayDate) : null)
                                    })(
                                        <DatePicker
                                            placeholder={'请选择'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="应收金额" required={false} subfix={<div>元</div>} >
                                    {getFieldDecorator('billMoney', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.billMoney

                                    })(
                                        <InputNumber
                                            style={{ color: "red" }}
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="账单周期始" required={false} >
                                    {getFieldDecorator('billBeginDate', {
                                        rules: [{
                                            required: false, message: '请选择',
                                        }],
                                        initialValue: (data.billBeginDate ? moment(data.billBeginDate) : null)
                                    })(
                                        <DatePicker
                                            placeholder={'请选择'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="账单周期末" required={false} labelstyle={{ width: "100%" }} >
                                    {getFieldDecorator('billEndDate', {
                                        rules: [{
                                            required: false, message: '请选择',
                                        }],
                                        initialValue: data.billEndDate ? moment(data.billEndDate) : null
                                    })(
                                        <DatePicker
                                            placeholder={'请选择'}
                                        />
                                    )}
                                </CustomCol>

                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="账单说明" required={false} colStyle={{ width: "501px" }}  >
                                    {getFieldDecorator('feeRemark', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.feeRemark
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }


}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Bill/components/Receiv/Edit.js